var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 6c-.384 0-.768.146-1.06.44L21.462 24.417 20 28l3.582-1.463L41.561 8.561A1.501 1.501 0 0 0 40.5 6zm-28 1C9.48 7 7 9.48 7 12.5v23c0 3.02 2.48 5.5 5.5 5.5h23c3.02 0 5.5-2.48 5.5-5.5v-17a1.5 1.5 0 1 0-3 0v17c0 1.398-1.102 2.5-2.5 2.5h-23a2.478 2.478 0 0 1-2.5-2.5v-23c0-1.398 1.102-2.5 2.5-2.5h17a1.5 1.5 0 1 0 0-3h-17z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.731bba5c83416627bd959ebf3e2abfe7.svg";
export { ForwardRef as ReactComponent };